import axios from 'axios';

const API_URL = '/api';

const apiService = {
  // Authentication
  login: (credentials) => axios.post(`${API_URL}/auth`, credentials),
  
  // Pages
  getPages: () => axios.get(`${API_URL}/pages`),
  getPageBySlug: (slug) => axios.get(`${API_URL}/pages?slug=${slug}`),
  updatePage: (page, token) => axios.put(`${API_URL}/pages`, page, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Menu
  getMenuItems: () => axios.get(`${API_URL}/menu`),
  getMenuCategories: () => axios.get(`${API_URL}/menu?categories=true`),
  createMenuItem: (item, token) => axios.post(`${API_URL}/menu`, item, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  updateMenuItem: (item, token) => axios.put(`${API_URL}/menu`, item, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  deleteMenuItem: (id, token) => axios.delete(`${API_URL}/menu`, {
    data: { id },
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Gallery
  getGallery: (activeOnly = true, token = null) => {
    const url = activeOnly ? `${API_URL}/gallery` : `${API_URL}/gallery?all=true`;
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    return axios.get(url, config);
  },
  addGalleryItem: (item, token) => axios.post(`${API_URL}/gallery`, item, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  updateGalleryItem: (item, token) => axios.put(`${API_URL}/gallery`, item, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  deleteGalleryItem: (id, token) => axios.delete(`${API_URL}/gallery`, {
    data: { id },
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Testimonials
  getTestimonials: (featured = false, token = null) => {
    const url = featured ? `${API_URL}/testimonials?featured=true` : `${API_URL}/testimonials`;
    const config = token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    return axios.get(url, config);
  },
  addTestimonial: (testimonial, token) => axios.post(`${API_URL}/testimonials`, testimonial, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  updateTestimonial: (testimonial, token) => axios.put(`${API_URL}/testimonials`, testimonial, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  deleteTestimonial: (id, token) => axios.delete(`${API_URL}/testimonials`, {
    data: { id },
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Settings
  getSettings: () => axios.get(`${API_URL}/settings`),
  updateSettings: (settings, token) => axios.post(`${API_URL}/settings`, settings, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Users
  getUsers: (token) => axios.get(`${API_URL}/users`, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  createUser: (user, token) => axios.post(`${API_URL}/users`, user, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  updateUser: (user, token) => axios.put(`${API_URL}/users`, user, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  deleteUser: (id, token) => axios.delete(`${API_URL}/users`, {
    data: { id },
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // File Upload
  uploadFile: (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    
    return axios.post(`${API_URL}/upload`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  
  // Menu Files
  getMenuFiles: () => axios.get(`${API_URL}/menu-files`),
  uploadMenuFile: (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    
    return axios.post(`${API_URL}/menu-files`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  updateMenuFile: (file, token) => axios.put(`${API_URL}/menu-files`, file, {
    headers: { Authorization: `Bearer ${token}` }
  }),
  deleteMenuFile: (id, token) => axios.delete(`${API_URL}/menu-files`, {
    data: { id },
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Menu PDF
  getMenuPdf: () => axios.get(`${API_URL}/menu-pdf`),
  uploadMenuPdf: (file, token) => {
    const formData = new FormData();
    formData.append('file', file);
    
    return axios.post(`${API_URL}/menu-pdf`, formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  deleteMenuPdf: (id, token) => axios.delete(`${API_URL}/menu-pdf`, {
    data: { id },
    headers: { Authorization: `Bearer ${token}` }
  }),
  
  // Contact
  sendContactMessage: (message) => axios.post(`${API_URL}/contact`, message)
};

export default apiService;
